import moment from 'moment'

export const trInt = (i: number | string): string => {
    return i.toLocaleString('da')
}

export const trCardCountInt = (i: number ): string | number=> {
    if(!i){
        return 0
    }
    else{
        return i
    }
}

export const trAmount = (amount: number | string): string => {
    return amount.toLocaleString('da', {minimumFractionDigits: 2})
}

export const trDate = (d: Date | string): string => {
    if (!d) {
        return ""
    }
    let d2: Date = new Date(d)
    if (isNaN(d2.getFullYear())) {
        return String(d)
    }
    return moment(d2).format('DD-MM-yyyy')
}

export const trDateTime = (d: Date | string): string => {
    if (!d) {
        return ""
    }
    let d2: Date = new Date(d)
    if (isNaN(d2.getFullYear())) {
        return String(d)
    }
    return moment(d2).format('DD-MM-yyyy') + ' ' + moment(d2).format('HH:mm')
}

export const trDateTimeSeconds = (d: Date | string): string => {
    if (!d) {
        return ""
    }
    let d2: Date = new Date(d)
    if (isNaN(d2.getFullYear())) {
        return String(d)
    }
    return moment(d2).format('DD-MM-yyyy') + ' ' + moment(d2).format('HH:mm:ss')
}

export const trCard = (original: string) => {
    switch (String(original)) {
        case "DANKORT_VISA": return "Visa/Dankort"
        case "MobilePay": return original
        case "Total": return original
        case "Card": return "Kort"
        case "Coin": return "Mønt"
        case "Free": return "Gratis"
        case "Other cards": return "Andre kort"
        case "CUP": return original
        case "MASTERCARD_EUROCARD": return "Mastercard Eurocard"
        case "OK": return "OK"
        case "OK_SVERIGE": return "OK Sverige"
    }

    var s = original.toLocaleLowerCase().replace('_', ' ')
    if (s.length > 0) {
        return s.charAt(0).toUpperCase() + s.slice(1)
    }
    return ""
}